import { render, staticRenderFns } from "./TransientNotification.vue?vue&type=template&id=08bf4f6e&scoped=true&"
import script from "./TransientNotification.vue?vue&type=script&lang=js&"
export * from "./TransientNotification.vue?vue&type=script&lang=js&"
import style0 from "./TransientNotification.vue?vue&type=style&index=0&id=08bf4f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bf4f6e",
  null
  
)

export default component.exports